import type { ThreadLink, ThreadRole } from "@schema/catalog.ts";
import { useCatalog } from "@/lib/catalog/context.tsx";
import styles from "./ThreadChips.module.css";

const ROLE_GLYPH: Record<ThreadRole, string> = {
  seed: "◌",
  advance: "→",
  payoff: "★",
  reference: "·",
};

const ROLE_LABEL: Record<ThreadRole, string> = {
  seed: "seeds",
  advance: "advances",
  payoff: "pays off",
  reference: "references",
};

export function ThreadChips({ links }: { links: ThreadLink[] }) {
  const catalog = useCatalog();
  if (links.length === 0) return null;
  const sorted = [...links].sort((a, b) => b.weight - a.weight);
  return (
    <ul className={styles.chips} aria-label="Narrative threads">
      {sorted.map((link) => {
        const thread = catalog.threads.find((t) => t.id === link.id);
        if (!thread) return null;
        return (
          <li
            key={link.id}
            className={styles.chip}
            title={`${ROLE_LABEL[link.role]} ${thread.title}: ${thread.description}`}
          >
            <span aria-hidden="true">{ROLE_GLYPH[link.role]}</span> {thread.title}
          </li>
        );
      })}
    </ul>
  );
}
